export default __webpack_public_path__ + "static/media/Img081.8227f465.jpg";